// proptypes are in mixin.
/* eslint react/prop-types:0*/

import createReactClass from "create-react-class";
import MobileMenuItem from "../../Mobile/MobileMenuItem";
import BaseOuterPanel from "./BaseOuterPanel";
import InnerPanel from "./InnerPanel";
import Styles from "./panel.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const MobilePanel = createReactClass({
  displayName: "MobilePanel",
  mixins: [BaseOuterPanel],
  getInitialState() {
    return {
      localIsOpen: false
    };
  },
  render() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(MobileMenuItem, {
        onClick: this.openPanel,
        caption: this.props.btnText,
        icon: this.props.mobileIcon
      }), this.isOpen() && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: Styles.overlay
        }), /*#__PURE__*/_jsx(InnerPanel, {
          theme: this.props.theme,
          caretOffset: "15px",
          doNotCloseFlag: this.getDoNotCloseFlag(),
          onDismissed: this.onDismissed,
          disableCloseOnFocusLoss: this.disableCloseOnFocusLoss,
          children: this.props.children
        })]
      })]
    });
  }
});
export default MobilePanel;